import ClearingAPI from '@shared/api';

export const {
    positions: { get: getPositions, getHistory: getHistoryPositions, putById: updatePostionById, postPositionLot },
    assignSecurity: { postAssignSecurity, postAssignBulkSecurity },
    securities: { getLogo },
} = ClearingAPI.settings;
